/* ===== Exotic India Art — custom theme JS (AJAX cart + wishlist + header UI) ===== */
(function () {
  "use strict";
  var CUR = window.exoCurrency || "INR";
  function fmt(cents) {
    try { return new Intl.NumberFormat("en-IN", { style: "currency", currency: CUR, maximumFractionDigits: 0 }).format((cents || 0) / 100); }
    catch (e) { return "₹" + Math.round((cents || 0) / 100).toLocaleString("en-IN"); }
  }
  window.exoFmt = fmt;

  /* On phones/tablets we skip the hover mini-cart drawer and send the user
     straight to the full cart page after adding an item. */
  function isMobileView() { return window.matchMedia("(max-width: 1023px)").matches; }

  /* XHR helper — bypasses Shopify Web Pixel Manager's fetch wrapper (which breaks /cart.js in some contexts) */
  function xhrJSON(method, url, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open(method, url, true);
      x.setRequestHeader("Content-Type", "application/json");
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) { try { resolve(JSON.parse(x.responseText || "{}")); } catch (e) { reject(e); } }
        else { var d = {}; try { d = JSON.parse(x.responseText); } catch (e) {} reject(d); }
      };
      x.onerror = function () { reject(new Error("network")); };
      x.send(body ? JSON.stringify(body) : null);
    });
  }

  /* ---------------- AJAX Cart ---------------- */
  var ExoCart = {
    threshold: (window.exoFreeShip || 0) * 100, // rupees -> paise
    async get() { return xhrJSON("GET", "/cart.js"); },
    async add(id, qty) {
      try {
        await xhrJSON("POST", "/cart/add.js", { items: [{ id: id, quantity: qty || 1 }] });
      } catch (e) { window.ExoToast && ExoToast.show((e && e.description) || "Could not add to cart", "error"); return; }
      if (isMobileView()) { window.location.href = "/cart"; return; }
      window.ExoToast && ExoToast.show("Added to cart");
      this.open();
      this.refresh();
    },
    async addItems(items) {
      try {
        await xhrJSON("POST", "/cart/add.js", { items: items });
      } catch (e) { window.ExoToast && ExoToast.show((e && e.description) || "Could not add to cart", "error"); return; }
      if (isMobileView()) { window.location.href = "/cart"; return; }
      window.ExoToast && ExoToast.show("Added to cart");
      this.open();
      this.refresh();
    },
    async refresh() { try { var c = await this.get(); this.render(c); } catch (e) { console.warn("cart refresh failed", e); } },
    async change(key, qty) { try { var c = await xhrJSON("POST", "/cart/change.js", { id: key, quantity: qty }); this.render(c); } catch (e) { console.warn(e); } },
    render(c) {
      document.querySelectorAll("[data-exo-cart-count]").forEach(function (el) { el.textContent = c.item_count; el.classList.toggle("is-empty", c.item_count === 0); });
      document.querySelectorAll("[data-exo-cart-count-txt]").forEach(function (el) { el.textContent = c.item_count + " item" + (c.item_count === 1 ? "" : "s"); });
      var body = document.getElementById("exo-cart-body");
      var foot = document.getElementById("exo-cart-foot");
      if (!body) return;
      if (!c.items || !c.items.length) {
        body.innerHTML = '<div class="exo-cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="exo-btn">Start Shopping</a></div>';
        if (foot) foot.style.display = "none";
        var sb = document.getElementById("exo-ship-bar"); if (sb) sb.style.display = "none";
        return;
      }
      if (foot) foot.style.display = "block";
      body.innerHTML = c.items.map(function (it) {
        var isAddon = it.properties && it.properties._addon === "lacquer";
        var cov = (it.properties && it.properties.Coverage) ? it.properties.Coverage : "";
        var img = it.image ? '<img src="' + it.image + '" alt="">' : "";
        var imgHtml = isAddon
          ? '<span class="exo-cart-line__img">' + img + '</span>'
          : '<a href="' + it.url + '" class="exo-cart-line__img">' + img + '</a>';
        var titleHtml = isAddon
          ? '<span class="exo-cart-line__title">' + it.product_title + '</span>'
          : '<a href="' + it.url + '" class="exo-cart-line__title">' + it.product_title + '</a>';
        var meta = isAddon
          ? ('Protective coating' + (cov ? ' &middot; ' + cov : "") + ' &middot; ' + fmt(it.final_line_price))
          : ('Qty ' + it.quantity + ' &middot; ' + fmt(it.final_price));
        return '<div class="exo-cart-line" data-key="' + it.key + '">' +
          imgHtml +
          '<div class="exo-cart-line__info">' + titleHtml +
          '<div class="exo-cart-line__meta">' + meta + '</div></div>' +
          '<button class="exo-cart-line__rm" data-exo-rm aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
          '</div>';
      }).join("");
      var bar = document.getElementById("exo-ship-bar");
      if (bar && this.threshold > 0) {
        bar.style.display = "block";
        var pct = Math.min(100, Math.round((c.total_price / this.threshold) * 100));
        var rem = this.threshold - c.total_price;
        bar.querySelector("[data-exo-ship-fill]").style.width = pct + "%";
        bar.querySelector("[data-exo-ship-msg]").innerHTML = rem > 0 ? ('Add <b>' + fmt(rem) + '</b> more for <b>FREE shipping</b>') : '<b>You\'ve unlocked FREE shipping! 🎉</b>';
      }
      var sub = document.getElementById("exo-cart-subtotal"); if (sub) sub.textContent = fmt(c.total_price);
    },
    open() { var mc = document.querySelector("[data-exo-minicart]"); if (mc) { mc.classList.add("is-open"); clearTimeout(this._t); this._t = setTimeout(function () { mc.classList.remove("is-open"); }, 4000); } },
    close() { var mc = document.querySelector("[data-exo-minicart]"); if (mc) mc.classList.remove("is-open"); }
  };
  window.ExoCart = ExoCart;

  /* ---------------- Wishlist (localStorage) ---------------- */
  var KEY = "exo_wishlist";
  var ExoWish = {
    all() { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; } },
    save(a) { localStorage.setItem(KEY, JSON.stringify(a)); this.count(); },
    has(h) { return this.all().some(function (i) { return i.handle === h; }); },
    toggle(item) { var a = this.all(); var i = a.findIndex(function (x) { return x.handle === item.handle; }); if (i > -1) { a.splice(i, 1); } else { a.unshift(item); } this.save(a); return i === -1; },
    count() { var n = this.all().length; document.querySelectorAll("[data-exo-wish-count]").forEach(function (el) { el.textContent = n; el.classList.toggle("is-empty", n === 0); }); return n; },
    syncButtons() { var self = this; document.querySelectorAll("[data-exo-wish]").forEach(function (b) { var h = b.getAttribute("data-handle"); b.classList.toggle("is-active", self.has(h)); }); }
  };
  window.ExoWish = ExoWish;

  /* ---------------- Toast ---------------- */
  var ExoToast = {
    wrap: null,
    ensure() { if (!this.wrap) { this.wrap = document.getElementById("exo-toast-wrap"); if (!this.wrap) { this.wrap = document.createElement("div"); this.wrap.id = "exo-toast-wrap"; document.body.appendChild(this.wrap); } } return this.wrap; },
    show(msg, kind) {
      var w = this.ensure();
      var t = document.createElement("div");
      t.className = "exo-toast" + (kind === "error" ? " is-error" : "");
      var ic = kind === "error"
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6 6 18M6 6l12 12"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m5 12 5 5 9-9"/></svg>';
      t.innerHTML = '<span class="exo-toast__ic">' + ic + '</span><span>' + msg + '</span>';
      w.appendChild(t);
      requestAnimationFrame(function () { t.classList.add("is-in"); });
      setTimeout(function () { t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 350); }, 2600);
    }
  };
  window.ExoToast = ExoToast;

  document.addEventListener("DOMContentLoaded", function () {
    ExoCart.refresh();
    ExoWish.count(); ExoWish.syncButtons();

    /* Wishlist page render */
    var wg = document.getElementById("exo-wishlist-grid");
    if (wg) {
      var renderWishlist = function () {
        var items = ExoWish.all();
        var empty = document.getElementById("exo-wishlist-empty");
        if (empty) empty.style.display = items.length ? "none" : "block";
        wg.innerHTML = items.map(function (i) {
          return '<a class="exo-pc" href="' + i.url + '"><div class="exo-pc__inner"><div class="exo-pc__imgbox">' +
            (i.image ? '<img class="exo-pc__img" src="' + i.image + '" alt="">' : "") +
            '<button type="button" class="exo-pc__wish exo-wish is-active" data-exo-wish data-handle="' + i.handle + '" data-title="' + i.title + '" data-image="' + (i.image || "") + '" data-price="' + (i.price || "") + '" data-url="' + i.url + '"><svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg></button>' +
            '</div><div class="exo-pc__body"><div class="exo-pc__title exo-serif">' + i.title + '</div>' +
            '<div class="exo-pc__price"><span class="now">' + (i.price || "") + '</span></div></div></div></a>';
        }).join("");
      };
      renderWishlist();
      document.addEventListener("exo:wishchange", renderWishlist);
    }

    /* Add-to-cart forms */
    document.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-exo-add-form]");
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qf = form.querySelector('[name="quantity"]'); var qty = qf ? parseInt(qf.value, 10) || 1 : 1;
      var addon = form.querySelector('[data-exo-addon]');
      var chk = addon && addon.querySelector('[data-addon-check]');
      var addonInput = addon && addon.querySelector('[data-addon-variant]');
      var addonId = addonInput ? parseInt(addonInput.value, 10) : 0;
      var addonKg = addon ? (parseInt(addon.getAttribute("data-addon-qty"), 10) || 1) : 1;
      if (chk && chk.checked && addonId) {
        ExoCart.addItems([
          { id: id, quantity: qty },
          { id: addonId, quantity: qty * addonKg, properties: { "Add-on for": form.getAttribute("data-product-title") || "", "Coverage": addonKg + " kg", "_addon": "lacquer" } }
        ]);
      } else {
        ExoCart.add(id, qty);
      }
    });

    /* Cart drawer interactions */
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-exo-cart-open]")) { e.preventDefault(); ExoCart.open(); }
      if (e.target.closest("[data-exo-cart-close]") || e.target.classList.contains("exo-cart-overlay")) { ExoCart.close(); }
      var line = e.target.closest(".exo-cart-line");
      if (line && e.target.closest("[data-exo-rm]")) {
        e.preventDefault();
        ExoCart.change(line.getAttribute("data-key"), 0);
      }
      /* product-card quick add */
      var qa = e.target.closest("[data-exo-quickadd]");
      if (qa) { e.preventDefault(); e.stopPropagation(); ExoCart.add(qa.getAttribute("data-variant-id"), 1); return; }
      /* wishlist toggle */
      var wb = e.target.closest("[data-exo-wish]");
      if (wb) {
        e.preventDefault(); e.stopPropagation();
        var item = { handle: wb.getAttribute("data-handle"), title: wb.getAttribute("data-title"), image: wb.getAttribute("data-image"), price: wb.getAttribute("data-price"), url: wb.getAttribute("data-url") };
        var added = ExoWish.toggle(item);
        wb.classList.toggle("is-active", added);
        window.ExoToast && ExoToast.show(added ? "Saved to wishlist" : "Removed from wishlist");
        document.dispatchEvent(new CustomEvent("exo:wishchange"));
      }
      /* header UI */
      if (e.target.closest("[data-exo-menu-open]")) document.documentElement.classList.add("exo-menu-open");
      if (e.target.closest("[data-exo-menu-close]") || e.target.classList.contains("exo-menu-overlay")) document.documentElement.classList.remove("exo-menu-open");
      if (e.target.closest("[data-exo-search-toggle]")) document.documentElement.classList.toggle("exo-search-open");
    });

    /* sticky header */
    var hdr = document.querySelector(".exo-header");
    if (hdr) window.addEventListener("scroll", function () { hdr.classList.toggle("is-stuck", window.scrollY > 60); }, { passive: true });
  });
})();
